import { FC, MutableRefObject } from 'react'
import { FONT_PRIMARY } from '../../util/colors'
import { AboutIcon } from '../icons/AboutIcon.component'
import { ContactIcon } from '../icons/ContactIcon.component'
import { FeaturesIcon } from '../icons/FeaturesIcon.component'
import { HomeIcon } from '../icons/HomeIcon.component'
import { refTypes } from './NavBar.component'
import { NavBarIcon } from './NavBarIcon.component'

export interface MobileIconHolderProps {
    refList: refTypes,
    action: (itemRef: MutableRefObject<any>) => void
}

export const MobileIconHolder: FC<MobileIconHolderProps> = ({ refList, action }) => {

    return (
        <>
            <NavBarIcon
                icon={<ContactIcon color={FONT_PRIMARY} />}
                text='Contact'
                refItem={refList.contact}
                action={action}
            />
            <NavBarIcon
                icon={<FeaturesIcon color={FONT_PRIMARY} />}
                text='Products'
                refItem={refList.feature}
                action={action}
            />
            <NavBarIcon
                icon={<AboutIcon color={FONT_PRIMARY} />}
                text='About'
                refItem={refList.about}
                action={action}
            />
            <NavBarIcon
                icon={<HomeIcon color={FONT_PRIMARY} />}
                text='Home'
                refItem={refList.home}
                action={action}
            />
        </>
    )
}